__turbopack_context__.v({
  "loading": "slow-loading-module-scss-module__bInshq__loading",
  "loading__box": "slow-loading-module-scss-module__bInshq__loading__box",
  "loading__loader": "slow-loading-module-scss-module__bInshq__loading__loader",
});
